import React from "react";
import { motion } from "framer-motion";
import "./AppSuiteSection.scss";
import { BookOpen, Users, BarChart3, Bell, MessageCircle, CheckCircle, Layers, ArrowUpRight } from "lucide-react";
import smsImg     from "../assets/app-sms.png";
import teacherImg from "../assets/app-teacher.png";
import bachhaImg  from "../assets/app-merabachha.png";

const PRODUCTS = [
  {
    tag:      "Web Platform",
    tagColor: "#0041e8",
    tagBg:    "#eff6ff",
    accent:   "#0041e8",
    num:      "01",
    name:     "School Management System",
    desc:     "Complete digital backbone for modern schools",
    features: ["Admissions & fee collection", "Centralized student data", "Reports & analytics"],
    img:      teacherImg,
    imgType:  "laptop",
    href:     "#",   // SMS website URL yahan daalo
    linkLabel:"Open Website",
  },
  {
    tag:      "Android",
    tagColor: "#0041e8",
    tagBg:    "#eff6ff",
    accent:   "#0041e8",
    num:      "02",
    name:     "CoGrad Teacher Tracking",
    desc:     "Real-time accountability for every classroom",
    features: ["Track teacher performance", "Monitor execution live", "School-wide accountability"],
    img:      smsImg,
    imgType:  "phone",
    href:     "https://play.google.com/store/apps/details?id=com.cogradteachingtrack&pcampaignid=web_share",
    linkLabel:"Download App",
  },
  {
    tag:      "Android",
    tagColor: "#0041e8",
    tagBg:    "#eff6ff",
    accent:   "#0041e8",
    num:      "03",
    name:     "Mera Bachha App",
    desc:     "Parents stay connected to child's growth",
    features: ["Academic progress tracking", "Instant alerts & updates", "School communication"],
    img:      bachhaImg,
    imgType:  "phone",
    href:     "https://play.google.com/store/apps/details?id=com.merabachhaapp&pcampaignid=web_share",
    linkLabel:"Download App",
  },
];

const card = (i) => ({
  initial:     { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport:    { once: true, margin: "-40px" },
  transition:  { duration: 0.4, delay: i * 0.08, ease: "easeOut" },
});

export default function AppSuiteSection() {
  return (
    <section className="as-wrap">
      <div className="as__inner">

        <motion.div
          className="as__head"
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
          viewport={{ once: true }} transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <div className="as__chip">✦ CoGrad App Suite</div>
          <h2 className="as__h2">One ecosystem. <span>Every stakeholder.</span></h2>
        </motion.div>

        <div className="as__grid">
          {PRODUCTS.map((p, i) => (
            <motion.a
              key={p.num}
              className="as__card"
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              {...card(i)}
            >

              {/* colored top bar */}
              <div className="as__card-bar" style={{ background: p.accent }} />

              {/* image preview */}
              <div className={`as__card-img as__card-img--${p.imgType}`}>
                <img src={p.img} alt={p.name} />
              </div>

              {/* content */}
              <div className="as__card-body">
                <div className="as__card-meta">
                  <span className="as__num">{p.num}</span>
                  <span className="as__tag" style={{ background: p.tagBg, color: p.tagColor }}>
                    {p.tag}
                  </span>
                </div>
                <h3 className="as__name">{p.name}</h3>
                <p className="as__desc">{p.desc}</p>
                <ul className="as__feats">
                  {p.features.map((f, j) => (
                    <li key={j} className="as__feat">
                      <span className="as__feat-dot" style={{ background: p.accent }} />
                      {f}
                    </li>
                  ))}
                </ul>

                <span className="as__link" style={{ color: p.accent }}>
                  {p.linkLabel} <ArrowUpRight size={13} />
                </span>
              </div>

            </motion.a>
          ))}
        </div>

      </div>
    </section>
  );
}
